import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Contabilidad, ContabilidadResponse } from '@p-p-portafolio/promociones/interfaces/contabilidad';
import { ContabilidadService } from '@p-p-portafolio/promociones/services/contabilidad.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDeletionComponent } from '@shared/components/confirm-deletion/confirm-deletion.component';
import { SwalService } from '@shared/utils/swal.service';
import { ContabilidadFormComponent } from '@p-p-portafolio/promociones/contabilidad-promocion/contabilidad-form/contabilidad-form.component';
import { ActividadesFormComponent } from './actividades-form/actividades-form.component';

@Component({
  selector: 'app-actividades',
  templateUrl: './actividades.component.html',
  styleUrls: ['./actividades.component.css']
})

export class ActividadesComponent implements OnInit {
  displayedColumns: string[] = [ 'actions', 'tipo', 'accion', 'identificador'];
  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  promocion = '';
  private readonly _width: string = '1000px';
  constructor(
    private contabilidadService: ContabilidadService,
    private route: ActivatedRoute,
    public _dialog: MatDialog,
    private _swalService: SwalService
  ) { }

  ngOnInit(): void {
    const routeParams = this.route.snapshot.paramMap;
    this.promocion = String(routeParams.get('promocion'));
    this.dataSource.paginator = this.paginator;
    this.getDataSource();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getDataSource() {
    this.contabilidadService.getAll(this.promocion).subscribe((res) => {
      this.dataSource.data = res;     
    });
  }

  add(){
    sessionStorage.setItem('promocion', this.promocion);
    const dialogRef = this._dialog.open(ActividadesFormComponent, {
      width: this._width
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.getDataSource();
    });
  }

  delete(model: Contabilidad) {
    model.sPromocion = this.promocion;
    const dialogRef = this._dialog.open(ConfirmDeletionComponent, {
      width: '310px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.contabilidadService.eliminar(model).subscribe((res) => {
          if (res) this._swalService.success('Eliminado');
          else this._swalService.error('No Eliminado');
          this.getDataSource();
        });
      }
    });
  }

  edit(model: Contabilidad){
    model.sPromocion = this.promocion;
    const dialogRef = this._dialog.open(ActividadesFormComponent, {
      width: this._width,
      data: model
    });
    dialogRef.afterClosed().subscribe((result) => {
     this.getDataSource();
    });
  }
}

